/* --- Responsive Reload on Breakpoint Cross --- */
(function($) {
  if (typeof $ === 'undefined') {
    // Якщо jQuery ще не завантажено, чекаємо
    document.addEventListener('DOMContentLoaded', function() {
      initReloadLogic(window.jQuery);
    });
  } else {
    // Якщо jQuery вже є, запускаємо одразу
    $(document).ready(function() {
      initReloadLogic($);
    });
  }

  function initReloadLogic($) {
    var desktopBreakpoint = 768;
    var wasMobile = $(window).width() < desktopBreakpoint;
    var resizeTimer;

    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var isMobile = $(window).width() < desktopBreakpoint;

        // Перевіряємо, чи ми перетнули межу (з мобільного на десктоп або навпаки)
        if (isMobile !== wasMobile) {
          // Перезавантажуємо сторінку, щоб уникнути конфліктів ініціалізації JS
          console.log('Breakpoint crossed. Reloading page...');
          location.reload();
        }
      }, 250); // Невелика затримка для оптимізації
    });
  }
})();